import {
  CONSENT_CATEGORIES,
  CONSENT_VERSION,
  type ConsentCategory,
} from './constants';

export type ConsentChoices = {
  necessary: true;
  externalContent: boolean;
};

export type ConsentState = {
  version: number;
  updatedAt: string;
  choices: ConsentChoices;
  /** True once the user has made an explicit Accept / Reject / Save choice */
  hasResponded: boolean;
};

export const defaultConsentState = (): ConsentState => ({
  version: CONSENT_VERSION,
  updatedAt: new Date().toISOString(),
  choices: {
    necessary: true,
    externalContent: false,
  },
  hasResponded: false,
});

export const acceptAllChoices = (): ConsentChoices => ({
  necessary: true,
  externalContent: true,
});

export const rejectAllChoices = (): ConsentChoices => ({
  necessary: true,
  externalContent: false,
});

export function isConsentCategory(value: string): value is ConsentCategory {
  return Object.values(CONSENT_CATEGORIES).includes(value as ConsentCategory);
}
